import client from './client';

export const revenueReport = () => client.get('/dashboard/revenue-report').then((r) => r.data);
